import React from "react"
import { useShallow } from "zustand/react/shallow"
import { capitalize } from "lodash"

// components
import Label from "components/Label/Label"
import { TextInput } from "components-design-system"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const DispersionRange = ({
  parameterType,
  dispersionType,
  dispersionValue,
  dispersionValueUpperBound,
  cell,
  cellArmId,
  onChange,
  measure,
}) => {
  const { readOnly } = useAuthoringViewStore(useShallow((state) => ({ readOnly: state.readOnly })))

  let showCiPercent = false
  if (measure?.dispersion_type === "confidence interval" && typeof measure?.ci_pct_pevel === "number") {
    showCiPercent = true
  }

  return (
    <div className="field-container">
      <TextInput
        label={capitalize(parameterType)}
        onChange={(e) => onChange(e.target.value, cellArmId, "value")}
        readOnly={readOnly}
        value={cell?.value}
      />
      <div className="range-container">
        <Label style={{ marginBottom: ".3rem", width: "100%" }}>
          {capitalize(dispersionType)}
          {showCiPercent ? ` ${measure.ci_pct_pevel}%` : ""}
        </Label>
        <div className="field-items">
          <TextInput
            style={{ marginRight: 8 }}
            onChange={(e) => onChange(e.target.value, cellArmId, "dispersion_value")}
            readOnly={readOnly}
            value={dispersionValue}
          />
          <Label style={{ marginBottom: 6 }}>to</Label>
          <TextInput
            style={{ marginLeft: 8 }}
            onChange={(e) => onChange(e.target.value, cellArmId, "dispersion_value_upper_bound")}
            readOnly={readOnly}
            value={dispersionValueUpperBound}
          />
        </div>
      </div>
    </div>
  )
}

export default DispersionRange
